import {GET_VIRTUAL_SHOWROOMS, VIRTUAL_SHOWROOMS_ERROR} from '../types'
import axios from 'axios'
import { ROUTE, PATH } from "../constants";

export const getVirtualShowroomActions = (token) => async dispatch => {
    
    try{
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        const API = `${process.env.REACT_APP_SERVER_HOST}${PATH}${ROUTE.VIRTUAL_SHOWROOMS}`;
        const res = await axios.get(API,config);
        
        dispatch( {
            type: GET_VIRTUAL_SHOWROOMS,
            payload: res.data
        })
    }
    catch(error){
        console.log(error);
        dispatch( {
            type: VIRTUAL_SHOWROOMS_ERROR,
            payload: error,
        })
    }

}

